import React, { useState, useEffect, useRef } from 'react';
import { X, Briefcase, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const JobBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    // Banner nach 3 Sekunden anzeigen
    timerRef.current = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    // KEIN localStorage - Banner kommt beim nächsten Besuch wieder
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    handleClose();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-in slide-in-from-bottom-4 duration-700">
      <div className="relative bg-gradient-to-br from-black to-[#00CCDD] text-white rounded-2xl shadow-2xl max-w-md overflow-hidden">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/20 backdrop-blur-sm hover:bg-white/30 flex items-center justify-center transition-colors group"
          aria-label="Schließen"
        >
          <X className="w-4 h-4 group-hover:scale-110 transition-transform" />
        </button>

        <div className="p-6">
          {/* Icon */}
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mr-4">
              <Briefcase className="w-6 h-6" />
            </div>
            <div>
              <h3 className="text-xl font-bold">Wir suchen Fachkräfte!</h3>
              <p className="text-sm text-white/80">Verstärken Sie unser Team</p>
            </div>
          </div>

          {/* Text */}
          <p className="text-white/90 mb-4 leading-relaxed">
            Sie sind Meister, Geselle oder erfahrene Fachkraft im Baugewerbe? 
            Werden Sie Teil unseres erfolgreichen Teams!
          </p>

          {/* CTA Button */}
          <Button
            onClick={scrollToContact}
            className="w-full bg-white text-black hover:bg-gray-100 font-semibold py-3 group"
          >
            Jetzt bewerben
            <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>

        {/* Decorative Accent */}
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#00CCDD] to-white"></div>
      </div>
    </div>
  );
};